<ion-toolbar color="primary">
  <ion-buttons slot="start">
    <ion-button (click)="onToggleMainMenu()">
      <ion-icon slot="icon-only" [src]="'menu' | getIcon"></ion-icon>
    </ion-button>

    <div class="app-logo-box c3-flex">
      <img class="app-logo ion-hide-sm-down" [src]="srcLogo" alt="Logo" routerLink="/" />
      <div class="app-logo-box-sm ion-hide-sm-up">
        <img class="app-logo" [src]="srcLogo" alt="Logo" routerLink="/" />
      </div>

      <div class="app-env-box">
        <b class="app-env-dev" *c3ShowTrecEnv="'development'">DEV</b>
        <b class="app-env-staging" *c3ShowTrecEnv="'staging'">STAGING</b>
      </div>
    </div>

    <ng-container *ngIf="showPatientInfo$ | async as showPatientInfo">
      <ng-container *ngIf="showPatientInfo.active && showPatientInfo.item; let patient">
        <ion-button
          class="ion-hide-md-down"
          c3Tooltip="Vai alla Lista Pazienti"
          [routerLink]="['/doctor-panel']"
        >
          <ion-icon slot="icon-only" [src]="'home' | getIcon"></ion-icon>
        </ion-button>

        <ion-icon
          class="ion-hide-md-down"
          [src]="'chevron-right' | getIcon"
          size="small"
        ></ion-icon>

        <ion-button
          class="ion-hide-md-down ion-margin-end app-left-btn"
          c3Tooltip="Vai all'anagrafica del Paziente"
          [routerLink]="[
            '/doctor-panel',
            'patients',
            patient.trecUserId,
            'page',
            { outlets: { 'patient-page': 'medical-records' } },
          ]"
          fill="clear"
          (click)="setAnagraficaPatient()"
        >
          <ion-icon slot="start" [src]="'account-heart-outline' | getIcon"></ion-icon>
          <span *ngIf="patient?.personalData?.surname">
            {{ patient?.personalData?.surname }} {{ patient?.personalData?.name }}
          </span>
          <span *ngIf="!patient?.personalData?.surname" class="c3-monospace">
            {{ patient?.personalData?.fiscalCode || "Sconosciuto" }}
          </span>
        </ion-button>

        <ng-container *ngFor="let context of patientContext">
          @if (contextInfo[context]?.label) {
            <ion-item color="transparent">
              <ion-avatar slot="start">
                <ion-img
                  class="app-img"
                  [src]="contextInfo[context]?.image"
                  alt="Logo contesto"
                ></ion-img>
              </ion-avatar>

              <ion-label class="ion-text-wrap">
                {{ contextInfo[context]?.label || "Nessun contesto" }}
              </ion-label>
            </ion-item>
          }
        </ng-container>
      </ng-container>
    </ng-container>
  </ion-buttons>

  <ion-buttons slot="end">
    <ion-spinner color="secondary" *ngIf="globalLoading$ | async"></ion-spinner>

    <ion-button
      class="ion-hide-md-down"
      *c3ShowTrecEnv="'development'"
      (click)="onOpenExternalServicesList($event)"
    >
      <ion-icon slot="start" [src]="'tools' | getIcon"></ion-icon>
      <span>Servizi</span>
    </ion-button>

    <ion-button
      class="ion-hide-md-down"
      *c3ShowTrecEnv="'development'"
      (click)="onOpenAppsList($event)"
    >
      <ion-icon slot="start" [src]="'cellphone-charging' | getIcon"></ion-icon>
      <span>Apps</span>
    </ion-button>

    <c3-dev-login-menu *ngIf="isDevMode" (login)="onDevLogin($event)"></c3-dev-login-menu>

    <ng-container *ngIf="isAuthenticated$ | async">
      <ng-container *ngTemplateOutlet="boxAuthenticatedTmpl"></ng-container>
    </ng-container>

    <ng-container *ngIf="!(isAuthenticated$ | async)">
      <ng-container *ngTemplateOutlet="boxNotAuthenticatedTmpl"></ng-container>
    </ng-container>
  </ion-buttons>
</ion-toolbar>

<ng-template #boxAuthenticatedTmpl>
  <ion-button
    class="ion-hide-md-down"
    *ngIf="isAdmin$ | async"
    (click)="onAdminPanel()"
    c3Tooltip="Pannello d'amministrazione"
  >
    <ion-icon
      aria-label="pannello amministrazione"
      slot="icon-only"
      [src]="'security' | getIcon"
    ></ion-icon>
  </ion-button>

  <ion-menu-toggle
    *ngIf="isDoctor$ | async"
    [menu]="SIDE_MENU_NOTIFICATION_CENTER"
    [autoHide]="false"
  >
    <ion-button>
      <ng-container *ngIf="pushStatus$ | async; let pushStatus">
        <ng-container [ngSwitch]="true">
          <ion-icon
            *ngSwitchCase="pushStatus === 'accepted' || pushStatus === 'just-accepted'"
            slot="icon-only"
            [src]="'bell-check-outline' | getIcon"
            [color]="pushStatus === 'just-accepted' ? 'success' : undefined"
            c3Tooltip="Notifiche in tempo reale attive!"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchCase="pushStatus === 'rejected'"
            slot="icon-only"
            [src]="'bell-remove-outline' | getIcon"
            c3Tooltip="Hai deciso di non ricevere notifiche in tempo reale"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchCase="pushStatus === 'need-permissions'"
            slot="icon-only"
            [src]="'bell-ring-outline' | getIcon"
            color="warning"
            c3Tooltip="Non hai ancora fornito il permesso per ricevere notifiche in tempo reale. Clicca per maggiori dettagli"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchCase="pushStatus === 'unsupported'"
            slot="icon-only"
            [src]="'bell-off-outline' | getIcon"
            color="medium"
            c3Tooltip="Questo brower non supporta le notifiche in tempo reale"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchCase="pushStatus === 'error'"
            slot="icon-only"
            [src]="'bell-remove-outline' | getIcon"
            color="danger"
            c3Tooltip="Si è verificato un errore, le notifiche in tempo reale non sono attive"
          >
          </ion-icon>

          <ion-icon
            *ngSwitchDefault
            slot="icon-only"
            [src]="'bell-off-outline' | getIcon"
            c3Tooltip="Stato ricezione notifiche sconosciuto"
          >
          </ion-icon>
        </ng-container>
      </ng-container>
    </ion-button>
  </ion-menu-toggle>

  <ion-button (click)="onOpenAccounQuickMenu($event)">
    <app-user-avatar
      class="app-user-avatar-mini ion-margin-end"
      slot="start"
      [personalData]="userData?.personalData"
      [isAdmin]="isAdmin$ | async"
      [isDoctor]="isDoctor$ | async"
    >
    </app-user-avatar>

    <span>{{ userData?.userMe?.associationId?.pass_auth }}</span>
    <div *ngIf="!userData?.userMe?.associationId?.pass_auth">
      <span>{{ userData?.personalData?.surname }}</span>
      <span>&nbsp;</span>
      <span>{{ userData?.personalData?.name }}</span>
    </div>

    <ion-icon slot="end" [src]="'chevron-down' | getIcon"></ion-icon>
  </ion-button>
</ng-template>

<ng-template #boxNotAuthenticatedTmpl>
  <ion-button (click)="onLogin()" color="secondary" fill="solid" shape="round">
    <span>Login</span>
  </ion-button>
</ng-template>
